import { useEffect } from "react";
import clarity from "@microsoft/clarity";

const ClarityAnalytics = () => {
	useEffect(() => {
		// Initialize Microsoft Clarity
		// You'll need to replace 'YOUR_PROJECT_ID' with your actual Clarity project ID
		const clarityProjectId = import.meta.env.VITE_CLARITY_PROJECT_ID;

		if (clarityProjectId) {
			clarity.init(clarityProjectId);
			// console.log(
			// 	"Microsoft Clarity initialized with project ID:",
			// 	clarityProjectId
			// );
		} else {
			console.warn(
				"Microsoft Clarity project ID not found. Please set VITE_CLARITY_PROJECT_ID in your environment variables."
			);
		}
	}, []);

	// This component doesn't render anything
	return null;
};

export default ClarityAnalytics;

// Additional utility functions for custom tracking
export const trackCustomEvent = (eventName, properties = {}) => {
	if (typeof clarity !== "undefined" && clarity.event) {
		clarity.event(eventName, properties);
	}
};

export const identifyUser = (
	userId,
	sessionId = null,
	pageId = null,
	userHint = null
) => {
	if (typeof clarity !== "undefined" && clarity.identify) {
		clarity.identify(userId, sessionId, pageId, userHint);
	}
};

export const setCustomTag = (key, value) => {
	if (typeof clarity !== "undefined" && clarity.set) {
		clarity.set(key, value);
	}
};
